export default "__VITE_ASSET__DiboowB4__"